import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { access, defaultRoute } from '../../../../common/Tool';
import LocaladminEventsByID from '../../LocaladminEventsByID';
import LocaladminEventsAdmins from '../../LocaladminEventsAdmins';
import LocaladminEventsOrders from '../../LocaladminEventsOrders';
import LocaladminEventsSerii from '../../LocaladminEventsSerii';
import LocaladminEventsFestivali from '../../LocaladminEventsFestivali';
import LocaladminEventsCalendar from '../../LocaladminEventsCalendar';
import { BreadcrumbsProvider, MenuLevelThreeContext, useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../common/Context';

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function Events(props) {
    let { id } = useParams();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    // const langSwitch = useLangSwitchContext();

    const siteAccess = useSelector(state => state.siteAccess.value);

    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status, () => { }); // Статусы
    const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

    const { menu: m } = props;

    const menu = (status, notify) => {
        const x = [
            {
                uuid: "calendar",
                default: true,
                name: "Мероприятия",
                component: (props) => (<LocaladminEventsCalendar {...props} auth={auth} />),
                role: [
                    { "ID": 15, "nazvanie": "АдминистраторОтделения" },
                    { "ID": 29, "nazvanie": "АдминистраторМероприятийРО" },
                ]
            },
            {
                uuid: ":id",
                hidden: true,
                name: "Мероприятие",
                component: (props) => (<LocaladminEventsByID {...props} auth={auth} />),
                role: [
                    { "ID": 15, "nazvanie": "АдминистраторОтделения" },
                    { "ID": 29, "nazvanie": "АдминистраторМероприятийРО" },
                ]
            },
            {
                uuid: "festivali",
                name: "Фестивали",
                component: (props) => (<LocaladminEventsFestivali {...props} auth={auth} />),
                role: [
                    { "ID": 15, "nazvanie": "АдминистраторОтделения" },
                    { "ID": 29, "nazvanie": "АдминистраторМероприятийРО" },
                ]
            },
            {
                uuid: "serii",
                name: "Серии",
                component: (props) => (<LocaladminEventsSerii {...props} auth={auth} />),
                role: [
                    { "ID": 15, "nazvanie": "АдминистраторОтделения" },
                    { "ID": 29, "nazvanie": "АдминистраторМероприятийРО" },
                ]
            },
            {
                uuid: "orders",
                name: "Заказы",
                component: (props) => (<LocaladminEventsOrders {...props} auth={auth} />),
                role: [
                    { "ID": 15, "nazvanie": "АдминистраторОтделения" },
                ]
            },
            {
                uuid: "admins",
                name: "Администраторы",
                component: (props) => (<LocaladminEventsAdmins {...props} auth={auth} />),
                role: [
                    { "ID": 15, "nazvanie": "АдминистраторОтделения" },
                ]
            },
        ]
        return x
    };

    const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

    return (
        <MenuLevelThreeContext.Provider value={menu(status, notify)}>
        {(!siteAccess || siteAccess == "allow") && <Routes>
            {defaultRoute(menu(status, notify), role_by_id)}
            {menu(status, notify).map((e, idx) => {
                if (e.component && access(e, role_by_id)) {

                    return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={
                        <BreadcrumbsProvider value={{
                            // parent: props?.level,
                            uuid: e?.uuid,
                            name: e?.name,
                            color: e?.color,
                            role: e?.role,
                            hidden: e.hidden
                        }}>
                            {e.component({})}
                        </BreadcrumbsProvider>} />

                }
            })}
        </Routes>}
    </MenuLevelThreeContext.Provider>
    );
}
